import { isGroupConversation } from 'dashboard/components-next/message/groupParticipant';

export const CONTACT_CLASSIFICATION_ATTRIBUTE =
  'aceleres_contact_classification';

export const DEFAULT_CONTACT_CLASSIFICATION = 'commercial_lead';

export const CONTACT_CLASSIFICATIONS = [
  {
    value: DEFAULT_CONTACT_CLASSIFICATION,
    label: 'Comercial / Lead',
    shortLabel: 'Lead',
    icon: 'i-lucide-briefcase',
    iconTileClass: 'rounded bg-[#e8f7f1] text-[#3a9b7a]',
    badgeClass: 'bg-n-teal-3 text-n-teal-11',
  },
  {
    value: 'personal_family',
    label: 'Familiar / Pessoal',
    shortLabel: 'Pessoal',
    icon: 'i-lucide-heart',
    iconTileClass: 'rounded bg-[#fcecf3] text-[#d96b91]',
    badgeClass: 'bg-n-slate-3 text-n-slate-11',
  },
  {
    value: 'internal_team',
    label: 'Equipe / Interno',
    shortLabel: 'Interno',
    icon: 'i-lucide-users',
    iconTileClass: 'rounded bg-[#e2f2e8] text-[#7b8790]',
    badgeClass: 'bg-n-blue-3 text-n-blue-11',
  },
  {
    value: 'spam_advertising',
    label: 'Spam / Propaganda',
    shortLabel: 'Spam',
    icon: 'i-lucide-shield',
    iconTileClass: 'rounded bg-[#e2f2e8] text-[#7b8790]',
    badgeClass: 'bg-n-ruby-3 text-n-ruby-11',
  },
  {
    value: 'supplier',
    label: 'Fornecedor',
    shortLabel: 'Fornecedor',
    icon: 'i-lucide-package',
    iconTileClass: 'rounded bg-[#f6f6de] text-[#c99a3d]',
    badgeClass: 'bg-n-amber-3 text-n-amber-11',
  },
  {
    value: 'commercial_offer',
    label: 'Oferta Comercial',
    shortLabel: 'Oferta comercial',
    icon: 'i-lucide-circle-dollar-sign',
    iconTileClass: 'rounded bg-[#f9e9e9] text-[#c86f73]',
    badgeClass: 'bg-n-ruby-3 text-n-ruby-11',
  },
];

// Onde o grupo do WhatsApp cai quando ninguém o classificou à mão. Reusa um
// tipo que já existe em vez de criar um só para grupo, e já conta como
// não-comercial do lado do Laravel (App\Support\ContactClassification).
const GROUP_FALLBACK_CLASSIFICATION =
  CONTACT_CLASSIFICATIONS.find(option => option.value === 'internal_team') ||
  CONTACT_CLASSIFICATIONS[0];

export const resolveContactClassification = contact => {
  const customAttributes =
    contact?.custom_attributes || contact?.customAttributes || {};
  const value = customAttributes[CONTACT_CLASSIFICATION_ATTRIBUTE];
  const stored = CONTACT_CLASSIFICATIONS.find(option => option.value === value);

  // Grupo do WhatsApp não é lead: ele cai em "Equipe / Interno".
  //
  // `commercial_lead` conta como "não classificado" aqui porque é o valor que
  // o próprio sistema atribui por omissão (413 grupos sem o atributo e 6 com
  // `commercial_lead`, nenhum com outro valor). Qualquer outra classificação
  // — Pessoal, Spam, Fornecedor, Oferta — é decisão humana deliberada e
  // continua vencendo.
  if (
    isGroupConversation(contact) &&
    (!stored || stored.value === DEFAULT_CONTACT_CLASSIFICATION)
  ) {
    return GROUP_FALLBACK_CLASSIFICATION;
  }

  return stored || CONTACT_CLASSIFICATIONS[0];
};

export const resolveContactClassificationSelection = (contact, value) => {
  const currentClassification = resolveContactClassification(contact).value;
  if (value !== 'internal_team' || currentClassification !== value)
    return value;

  // Grupos do WhatsApp são sempre internos quando a classificação atual é o
  // fallback; mantenha esse valor ao selecionar a mesma opção.
  if (isGroupConversation(contact)) return currentClassification;

  // Classificação é uma escolha de opção única: selecionar a mesma opção
  // novamente mantém o valor. Os pontos de entrada podem usar isso para
  // reconciliar o vínculo auditado de Número da Equipe.
  return value;
};

export const shouldReconcileTeamNumberClassification = (contact, value) =>
  value === 'internal_team' &&
  resolveContactClassification(contact).value === value &&
  !isGroupConversation(contact);
